<template>
  <header
    class="grid items-center grid-cols-[max-content_1fr_max-content] bg-interactive-interactiveBg px-4 z-20">
    <div>
      <div class="flex gap-2 md:contents">
        <a class="flex items-center md:items-start md:overflow-hidden md:min-w-max" href="https://hyperfoundation.org/">
          <img alt="Aster Logo" width="24" height="24"
            class="h-6 w-6 relative block md:hidden" src="../assets/logo.svg" style="color: transparent;">
          <div class="hidden md:block">
            <img width="125" height="28"
              class="w-auto h-7 relative hidden dark:md:hidden md:block dark:!hidden" alt="Aster Logo"
              src="/index_files/logo-black.svg">
              <svg width="115" height="32" viewBox="0 0 115 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_0_3)">
<mask id="mask0_0_3" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="115" height="32">
<path d="M115 0H0V32H115V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_0_3)">
<path d="M20.4523 14.5389C20.471 16.2176 20.1196 17.8218 19.4292 19.3544C18.4434 21.5368 16.0799 23.3213 13.9218 21.4218C12.1616 19.8736 11.8351 16.7306 9.19798 16.2705C5.7088 15.8477 5.62483 19.8923 3.34536 20.3492C0.804661 20.8653 -0.0380915 16.5938 -0.000774032 14.6539C0.0365434 12.714 0.552769 9.98759 2.76072 9.98759C5.30142 9.98759 5.47245 13.8332 8.69731 13.6249C11.8911 13.4073 11.947 9.40624 14.0337 7.69329C15.8343 6.2135 17.952 7.29847 19.0125 9.07982C19.9952 10.7275 20.4274 12.6612 20.4492 14.5389H20.4523Z" fill="url(#paint0_linear_0_3)"/>
<path d="M30.0352 21.0644V8.08203H31.2666V13.6965H38.8607V8.08203H40.0736V21.0644H38.8607V14.7411H31.2666V21.0644H30.0352Z" fill="white"/>
<path d="M43.2892 25.0005L44.9685 20.8223L41.3301 12.0928H42.5989L44.9872 18.0057C45.124 18.3663 45.3168 18.8451 45.5656 19.442C45.6029 19.3549 45.6402 19.2586 45.6776 19.1529C45.7149 19.0472 45.7522 18.9508 45.7895 18.8638C45.8642 18.7021 45.9295 18.5498 45.9854 18.4068C46.0414 18.2638 46.0943 18.1239 46.144 17.9871L48.3831 12.0928H49.5959L44.5021 25.0005H43.2892Z" fill="white"/>
<path d="M50.8262 25V12.0922H51.983V13.7336C52.2816 13.1741 52.7138 12.7171 53.2798 12.3627C53.8458 12.0083 54.4771 11.8311 55.1737 11.8311C56.0071 11.8311 56.7317 12.0331 57.3474 12.4373C57.9631 12.8414 58.4358 13.401 58.7655 14.116C59.0951 14.8311 59.2599 15.6425 59.2599 16.5502C59.2599 17.458 59.0889 18.2912 58.7468 19.0124C58.4047 19.7336 57.9227 20.2994 57.3007 20.7098C56.6788 21.1202 55.9698 21.3254 55.1737 21.3254C54.5019 21.3254 53.8831 21.1637 53.3171 20.8404C52.7511 20.5171 52.3064 20.0445 51.983 19.4228V25H50.8262ZM55.0057 20.3927C55.6152 20.3927 56.1532 20.2311 56.6197 19.9077C57.0862 19.5844 57.4438 19.1336 57.6926 18.5554C57.9414 17.9772 58.0658 17.3088 58.0658 16.5502C58.0658 15.7917 57.9383 15.1637 57.6833 14.5917C57.4283 14.0197 57.0706 13.5751 56.6104 13.258C56.1501 12.9409 55.6152 12.7824 55.0057 12.7824C54.3962 12.7824 53.8769 12.9378 53.4104 13.2487C52.9439 13.5596 52.5801 14.001 52.3189 14.573C52.0576 15.145 51.927 15.8041 51.927 16.5502C51.927 17.2963 52.0576 17.9772 52.3189 18.5554C52.5801 19.1336 52.9408 19.5844 53.4011 19.9077C53.8613 20.2311 54.3962 20.3927 55.0057 20.3927Z" fill="white"/>
<path d="M64.7835 21.3254C63.9376 21.3254 63.1944 21.1388 62.5538 20.7658C61.9132 20.3927 61.4156 19.8456 61.0611 19.1243C60.7066 18.4031 60.5293 17.5388 60.5293 16.5316C60.5293 15.6362 60.7128 14.8311 61.0797 14.116C61.4467 13.401 61.9474 12.8414 62.5818 12.4373C63.2162 12.0331 63.9252 11.8311 64.7089 11.8311C65.5547 11.8311 66.2762 12.0238 66.8733 12.4093C67.4703 12.7948 67.9244 13.3388 68.2354 14.0414C68.5463 14.744 68.7018 15.5616 68.7018 16.4943V16.7368H61.6861C61.6861 17.5077 61.8167 18.1668 62.078 18.714C62.3392 19.2611 62.7062 19.6777 63.1788 19.9637C63.6515 20.2497 64.1926 20.3927 64.8021 20.3927C65.5236 20.3927 66.1238 20.2217 66.6027 19.8798C67.0816 19.5378 67.3771 19.0248 67.489 18.3409H68.6458C68.5588 18.9129 68.3566 19.4228 68.0394 19.8704C67.7222 20.3181 67.2869 20.6725 66.7333 20.9336C66.1798 21.1948 65.5298 21.3254 64.7835 21.3254ZM67.4703 15.8601C67.4579 14.9274 67.2091 14.1813 66.724 13.6217C66.2389 13.0621 65.5672 12.7824 64.7089 12.7824C63.8506 12.7824 63.1882 13.0715 62.6471 13.6497C62.106 14.2279 61.7981 14.9647 61.7235 15.8601H67.4703Z" fill="white"/>
<path d="M70.4904 21.0645V12.0924H71.6472V13.8831C71.896 13.2862 72.2848 12.795 72.8134 12.4095C73.3421 12.024 73.9609 11.8313 74.67 11.8313C74.8441 11.8313 75.012 11.8437 75.1737 11.8686V12.9878C74.9623 12.9629 74.7757 12.9505 74.614 12.9505C74.0169 12.9505 73.4945 13.0841 73.0466 13.3515C72.5988 13.6189 72.2537 14.0012 72.0111 14.4987C71.7685 14.9961 71.6472 15.5743 71.6472 16.2334V21.0645H70.4904Z" fill="white"/>
<path d="M78.0471 20.8158L77.9942 21.0676H74.334L74.3869 20.8158C75.3975 20.707 75.8111 20.4179 75.9728 19.6625L78.0284 9.97852C78.2461 8.98681 77.9382 8.82515 76.8933 9.03966L76.9462 8.78785L79.1821 8.0293H79.434L76.9618 19.6593C76.8 20.4179 77.0706 20.7039 78.044 20.8127L78.0471 20.8158Z" fill="white"/>
<path d="M82.1701 20.8158L82.1173 21.0676H78.457L78.5099 20.8158C79.5206 20.707 79.9342 20.4179 80.0959 19.6625L81.3398 13.765C81.5575 12.7547 81.2683 12.6117 80.2047 12.8262L80.2576 12.5744L82.4935 11.8158H82.7454L81.0848 19.6594C80.9231 20.4179 81.1936 20.7039 82.167 20.8127L82.1701 20.8158ZM82.7828 8.55469C83.271 8.55469 83.5944 8.93396 83.5415 9.41894C83.47 9.90702 83.0378 10.2676 82.5682 10.2676C82.0644 10.2676 81.7192 9.90702 81.7938 9.41894C81.8467 8.93085 82.2821 8.55469 82.7859 8.55469H82.7828Z" fill="white"/>
<path d="M88.4734 23.6663L89.4779 19.028C88.8466 20.3989 87.5312 21.3347 86.1411 21.3347C83.9052 21.3347 82.8572 19.2238 83.5258 16.0684C83.9953 13.7772 86.0509 11.8124 88.4859 11.8124C89.6054 11.8124 90.5228 12.316 90.9022 13.0559L91.7512 11.8124H92.003L89.4655 23.6601C89.2851 24.4715 89.935 24.6331 90.585 24.7419L90.5321 24.9938H86.3308L86.3837 24.7419C87.5934 24.6331 88.2962 24.4715 88.4765 23.6601L88.4734 23.6663ZM86.7382 20.6694C87.8919 20.6694 89.0456 19.6777 89.5867 18.487L90.3455 14.9337C90.5446 13.6528 89.9319 12.3191 88.1811 12.3191C86.4303 12.3191 85.062 13.8331 84.6111 16.0497C84.0327 18.773 84.8443 20.6663 86.7382 20.6663V20.6694Z" fill="white"/>
<path d="M104.518 20.8158L104.465 21.0676H100.805L100.858 20.8158C101.868 20.707 102.282 20.4179 102.444 19.6625L103.687 13.765C103.905 12.7547 103.616 12.6117 102.552 12.8262L102.605 12.5744L104.841 11.8158H105.093L103.432 19.6594C103.271 20.4179 103.541 20.7039 104.515 20.8127L104.518 20.8158ZM105.13 8.55469C105.619 8.55469 105.942 8.93396 105.889 9.41894C105.818 9.90702 105.385 10.2676 104.916 10.2676C104.412 10.2676 104.067 9.90702 104.141 9.41894C104.194 8.93085 104.63 8.55469 105.134 8.55469H105.13Z" fill="white"/>
<path d="M99.3212 19.6401L100.152 15.6795L100.969 11.8184H100.717L98.4815 12.5769L98.4287 12.8287C99.4736 12.6111 99.7814 12.7572 99.5638 13.7676L98.5002 18.7976C97.3278 19.8982 96.4975 20.5479 95.4868 20.5479C94.2429 20.5479 93.593 19.6992 93.9008 18.2412L95.2722 11.8215H95.0203L92.7658 12.58L92.7129 12.8318C93.7764 12.6142 94.0656 12.7603 93.8666 13.7707L92.8933 18.3873C92.5139 20.1002 93.3815 21.3437 94.9861 21.3437C96.0497 21.3437 96.9857 20.75 98.4256 19.2049L98.3572 19.5313V19.5469H98.354L98.0306 21.0764H100.354L100.407 20.8028C99.4331 20.694 99.1626 20.4049 99.3243 19.6494L99.3212 19.6401Z" fill="white"/>
<path d="M114.269 11.4801L114.996 8.0293H114.745L112.509 8.78785L112.456 9.03966C113.501 8.82204 113.809 8.98681 113.591 9.97852L112.96 12.9163C112.562 12.248 111.697 11.8158 110.686 11.8158C108.233 11.8158 106.196 13.7619 105.673 16.2334C105.042 19.2272 106.071 21.335 108.326 21.335C109.732 21.335 111.069 20.3806 111.681 19.0096L111.52 19.7961L111.249 21.0645L113.572 21.0459L113.625 20.7941C112.652 20.6853 112.381 20.3961 112.543 19.6407L114.266 11.4801H114.269ZM111.787 18.4687C111.246 19.678 110.092 20.6697 108.92 20.6697C107.026 20.6697 106.214 18.7764 106.756 16.2148C107.259 13.8334 108.702 12.3195 110.382 12.3195C112.173 12.3195 112.77 13.7402 112.534 15.0334L112.45 15.4252L111.79 18.4687H111.787Z" fill="white"/>
</g>
</g>
<defs>
<linearGradient id="paint0_linear_0_3" x1="19" y1="7" x2="1" y2="20" gradientUnits="userSpaceOnUse">
<stop stop-color="#97FCE4"/>
<stop offset="1" stop-color="#56867A"/>
</linearGradient>
<clipPath id="clip0_0_3">
<rect width="115" height="32" fill="white"/>
</clipPath>
</defs>
</svg>


          </div>
          <span class="sr-only">Aster</span>
        </a>
      </div>
    </div>
    <div class="hidden md:flex items-center gap-8 pl-8 relative">
      <nav aria-label="Main" class="relative flex max-w-max flex-1 items-center justify-center w-full">
        <div style="position: relative;">
          <ul class="flex flex-1 list-none items-center justify-center gap-6">
            <a
              class="inline-flex h-9 w-max items-center justify-center rounded-md hover:bg-accent focus:bg-accent focus:text-accent-foreground outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 text-t-third hover:text-t-primary p-0 text-subtitle1 font-normal"
              href="https://app.hyperliquid.xyz/trade">Perpetual</a>
            <li class="relative">
              <a
                class="h-9 w-max justify-center rounded-md hover:bg-accent focus:bg-accent focus:text-accent-foreground outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 text-t-third hover:text-t-primary p-0 text-subtitle1 font-normal flex items-center gap-1 flex-row"
                href="https://app.hyperliquid.xyz/trade"><span>1001x</span></a>
            </li>
            <a
              class="inline-flex h-9 w-max items-center justify-center rounded-md hover:bg-accent focus:bg-accent focus:text-accent-foreground outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 text-t-third hover:text-t-primary p-0 text-subtitle1 font-normal"
              href="https://app.hyperliquid.xyz/trade">Spot</a>
            <li class="relative">
              <a
                class="h-9 w-max justify-center rounded-md hover:bg-accent focus:bg-accent focus:text-accent-foreground outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 text-t-third hover:text-t-primary p-0 text-subtitle1 font-normal flex items-center gap-1 flex-row"
                href="https://app.hyperliquid.xyz/portfolio"><span>Portfolio</span></a>
            </li>
            <li class="relative">
              <a
                class="h-9 w-max justify-center rounded-md hover:bg-accent focus:bg-accent focus:text-accent-foreground outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 hover:text-t-primary p-0 text-subtitle1 font-normal text-t-primary flex items-center gap-1 flex-row"
                href="/"><span>Referral</span></a>
            </li>
            <li class="relative" @mouseenter="showRewardsDropdown" @mouseleave="hideRewardsDropdown">
              <button
                class="inline-flex h-9 w-max items-center justify-center rounded-md hover:bg-accent focus:bg-accent focus:text-accent-foreground outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 text-subtitle1 p-0 text-t-third hover:text-t-primary font-normal">
                <div class="flex items-center gap-1">Rewards</div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="relative top-[1px] ml-2 size-3 transition duration-300"
                  :class="{ 'rotate-180': isRewardsDropdownOpen }"
                  aria-hidden="true">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              <LandingPageRewardsDropdown
                :is-open="isRewardsDropdownOpen"
                @mouseenter="showRewardsDropdown"
                @mouseleave="hideRewardsDropdown" />
            </li>
            <li class="relative" @mouseenter="showMoreDropdown" @mouseleave="hideMoreDropdown">
              <button
                class="inline-flex h-9 w-max items-center justify-center rounded-md hover:bg-accent focus:bg-accent focus:text-accent-foreground outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 text-subtitle1 p-0 text-t-third hover:text-t-primary font-medium">
                <span class="text-subtitle1 text-t-third hover:text-t-primary">More</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="relative top-[1px] ml-2 size-3 transition duration-300"
                  :class="{ 'rotate-180': isMoreDropdownOpen }"
                  aria-hidden="true">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              <LandingPageMoreDropdown
                :is-open="isMoreDropdownOpen"
                @mouseenter="showMoreDropdown"
                @mouseleave="hideMoreDropdown" />
            </li>
            <li class="relative">
              <a
                class="h-9 w-max justify-center rounded-md hover:bg-accent focus:bg-accent focus:text-accent-foreground outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 text-t-third hover:text-t-primary p-0 text-subtitle1 font-normal flex items-center gap-1 flex-row"
                href="https://app.hyperliquid.xyz/announcements"><span>Rocket Launch</span>
                <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_9232_53451762799494092)">
                    <path
                      d="M5.7523 0.99375L6.99292 0V1.35938C6.99292 1.76875 7.16167 2.1625 7.45854 2.44375L10.1054 4.96875C11.6304 6.425 12.4929 8.44375 12.4929 10.5531C12.4929 13.5625 10.0554 16 7.04604 16H6.11167C3.00854 16 0.49292 13.4844 0.49292 10.3813C0.49292 8.58125 1.39292 6.9 2.88979 5.90312L3.49292 5.5V9C3.49292 10.1031 4.38979 11 5.49292 11C6.59605 11 7.49292 10.1031 7.49292 9V8.87813C7.49292 8.31563 7.26792 7.775 6.87105 7.37813L5.47417 5.98125C4.84604 5.35312 4.49292 4.5 4.49292 3.60938C4.49292 2.59063 4.95542 1.62812 5.7523 0.990625V0.99375Z"
                      fill="url(#paint0_linear_9232_45671762799494092)"></path>
                  </g>
                  <defs>
                    <linearGradient id="paint0_linear_9232_45671762799494092" x1="6.49292" y1="0" x2="6.49292" y2="16"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#EFBE84"></stop>
                      <stop offset="1" stop-color="#F35757"></stop>
                    </linearGradient>
                    <clipPath id="clip0_9232_53451762799494092">
                      <rect width="12" height="16" fill="white" transform="translate(0.49292)"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </li>
            <li class="relative">
              <a href="https://app.hyperliquid.xyz/announcements"
                class="inline-flex h-9 w-max items-center justify-center rounded-md hover:bg-accent focus:bg-accent focus:text-accent-foreground outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 text-subtitle1 p-0 text-t-third hover:text-t-primary font-normal">
                <div class="rotating-box rounded-full">
                  <div
                    class="group flex items-center cursor-pointer gap-1.5 relative rounded-full px-3 py-2 dark:bg-interactive-interactiveBg bg-[image:linear-gradient(0deg,#F6ECE0,#F6ECE0),linear-gradient(180deg,rgba(236,102,73,0.05)_0%,rgba(239,190,132,0.2)_100%)] dark:bg-[image:linear-gradient(180deg,rgb(var(--colors-interactive-primary)/0.05)_0%,rgb(var(--colors-interactive-primary)/0.2)_100%)]">
                    <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_2)">
<mask id="mask0_1_2" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-6" width="115" height="32">
<path d="M115 -6H0V26H115V-6Z" fill="white"/>
</mask>
<g mask="url(#mask0_1_2)">
<path d="M20.4523 8.5389C20.471 10.2176 20.1196 11.8218 19.4292 13.3544C18.4434 15.5368 16.0799 17.3213 13.9218 15.4218C12.1616 13.8736 11.8351 10.7306 9.19798 10.2705C5.7088 9.8477 5.62483 13.8923 3.34536 14.3492C0.804661 14.8653 -0.0380915 10.5938 -0.000774031 8.6539C0.0365434 6.714 0.552769 3.98759 2.76072 3.98759C5.30142 3.98759 5.47245 7.8332 8.69731 7.6249C11.8911 7.4073 11.947 3.40624 14.0337 1.69329C15.8343 0.2135 17.952 1.29847 19.0125 3.07982C19.9952 4.7275 20.4274 6.6612 20.4492 8.5389H20.4523Z" fill="url(#paint0_linear_1_2)"/>
</g>
</g>
<defs>
<linearGradient id="paint0_linear_1_2" x1="19" y1="1" x2="1" y2="14" gradientUnits="userSpaceOnUse">
<stop stop-color="#97FCE4"/>
<stop offset="1" stop-color="#56867A"/>
</linearGradient>
<clipPath id="clip0_1_2">
<rect width="21" height="17" fill="white"/>
</clipPath>
</defs>
</svg>


                    <span
                      class="dark:text-highLight text-t-link dark:group-hover:text-t-primary group-hover:text-t-linkHover text-subtitle1">Airdrop</span>
                  </div>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="relative top-[1px] ml-2 size-3 transition duration-300 hidden"
                  aria-hidden="true">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="hidden md:flex items-center justify-end gap-3">
      <div class="grid auto-cols-max grid-flow-col gap-3">
        <div class="flex items-center">
          <a href="https://t.me/hyperfoundation_bot/link">
          <button
            class="button inline-flex items-center justify-center gap-2 focus-visible:outline-none disabled:cursor-not-allowed button bg-primary-gradient text-t-dark hover:bg-interactive-primaryActive disabled:bg-none hover:bg-none active:bg-interactive-primaryActive disabled:bg-primary-gradient disabled:text-t-disabled disabled:opacity-[0.7] py-[0.375rem] px-3 rounded-none text-subtitle1 whitespace-nowrap h-9"
            type="button" aria-label="Connect wallet">
            <span class="hidden sm:contents">Copy now</span>
            <span class="contents sm:hidden">Copy now</span>
          </button>
          </a>
        </div>
      </div>
      <div class="relative" @mouseenter="showSettingsDropdown" @mouseleave="hideSettingsDropdown">
        <button type="button"
          class="grid place-content-center border border-border-line w-9 h-9 hover:bg-interactive-interactiveBgHover">
          <span class="sr-only">Open Settings</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
            class="w-6 h-6 text-t-primary">
            <path fill="currentColor" fill-rule="evenodd"
              d="M5.206 8.077 12 4.155l6.794 3.922v7.846L12 19.845l-6.794-3.922V8.077ZM12 3l7.794 4.5v9L12 21l-7.794-4.5v-9L12 3Zm3 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm1 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
              clip-rule="evenodd"></path>
          </svg>
        </button>
        <LandingPageSettingsDropdown
          :is-open="isSettingsDropdownOpen"
          @mouseenter="showSettingsDropdown"
          @mouseleave="hideSettingsDropdown" />
      </div>
    </div>
    <div class="justify-end grid auto-cols-max col-span-2 grid-flow-col gap-4 md:hidden">
      <div class="grid auto-cols-max grid-flow-col gap-2 md:hidden">
        <div class="flex items-center">
          <a href="https://t.me/hyperfoundation_bot/link">
          <button
            class="button inline-flex items-center justify-center gap-2 focus-visible:outline-none disabled:cursor-not-allowed button bg-primary-gradient text-t-dark hover:bg-interactive-primaryActive disabled:bg-none hover:bg-none active:bg-interactive-primaryActive disabled:bg-primary-gradient disabled:text-t-disabled disabled:opacity-[0.7] py-[0.375rem] px-3 rounded-none text-subtitle1 whitespace-nowrap h-9"
            type="button" aria-label="Connect wallet">
            <span class="hidden sm:contents">Copy now</span>
            <span class="contents sm:hidden">Copy now</span>
          </button>
        </a>
        </div>
      </div>
      <div class="relative" @mouseenter="showSettingsDropdown" @mouseleave="hideSettingsDropdown">
        <button type="button"
          class="grid place-content-center border border-border-line w-9 h-9 hover:bg-interactive-interactiveBgHover">
          <span class="sr-only">Open Settings</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
            class="w-6 h-6 text-t-primary">
            <path fill="currentColor" fill-rule="evenodd"
              d="M5.206 8.077 12 4.155l6.794 3.922v7.846L12 19.845l-6.794-3.922V8.077ZM12 3l7.794 4.5v9L12 21l-7.794-4.5v-9L12 3Zm3 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm1 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
              clip-rule="evenodd"></path>
          </svg>
        </button>
        <LandingPageSettingsDropdown
          :is-open="isSettingsDropdownOpen"
          @mouseenter="showSettingsDropdown"
          @mouseleave="hideSettingsDropdown" />
      </div>
      <button type="button" class="md:hidden" @click="toggleMobileMenu">
        <div id="tour-guide-off-canvas-menu"
          class="flex items-center justify-center w-[1.625rem] h-[1.625rem] md:hidden leading-none bg-border-lineSubtle">
          <span class="justify-center w-[0.875rem] h-[0.875rem] md:hidden leading-none flex items-center text-t-primary">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M18 1.0332L0 1.0332V0.0332031H18V1.0332ZM18 8.49987L0 8.49987V7.49987L18 7.49987V8.49987ZM0 15.9665L18 15.9665V14.9665L0 14.9665V15.9665Z"
                fill="currentColor"></path>
            </svg>
            <span class="sr-only">Toggle Menu</span>
          </span>
        </div>
      </button>
    </div>
    <LandingPageMobileMenu :is-open="isMobileMenuOpen" @close="closeMobileMenu" />
  </header>
</template>

<script>
import LandingPageRewardsDropdown from './LandingPageRewardsDropdown.vue'
import LandingPageMoreDropdown from './LandingPageMoreDropdown.vue'
import LandingPageSettingsDropdown from './LandingPageSettingsDropdown.vue'
import LandingPageMobileMenu from './LandingPageMobileMenu.vue'

export default {
  name: 'LandingPageHeader',
  components: {
    LandingPageRewardsDropdown,
    LandingPageMoreDropdown,
    LandingPageSettingsDropdown,
    LandingPageMobileMenu
  },
  data() {
    return {
      isRewardsDropdownOpen: false,
      isMoreDropdownOpen: false,
      isSettingsDropdownOpen: false,
      isMobileMenuOpen: false,
      rewardsDropdownTimeout: null,
      moreDropdownTimeout: null,
      settingsDropdownTimeout: null
    }
  },
  methods: {
    showRewardsDropdown() {
      if (this.rewardsDropdownTimeout) {
        clearTimeout(this.rewardsDropdownTimeout)
        this.rewardsDropdownTimeout = null
      }
      this.isRewardsDropdownOpen = true
    },
    hideRewardsDropdown() {
      this.rewardsDropdownTimeout = setTimeout(() => {
        this.isRewardsDropdownOpen = false
      }, 150)
    },
    showMoreDropdown() {
      if (this.moreDropdownTimeout) {
        clearTimeout(this.moreDropdownTimeout)
        this.moreDropdownTimeout = null
      }
      this.isMoreDropdownOpen = true
    },
    hideMoreDropdown() {
      this.moreDropdownTimeout = setTimeout(() => {
        this.isMoreDropdownOpen = false
      }, 150)
    },
    showSettingsDropdown() {
      if (this.settingsDropdownTimeout) {
        clearTimeout(this.settingsDropdownTimeout)
        this.settingsDropdownTimeout = null
      }
      this.isSettingsDropdownOpen = true
    },
    hideSettingsDropdown() {
      this.settingsDropdownTimeout = setTimeout(() => {
        this.isSettingsDropdownOpen = false
      }, 150)
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      this.updateBodyScroll()
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      this.updateBodyScroll()
    },
    updateBodyScroll() {
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  beforeUnmount() {
    if (this.rewardsDropdownTimeout) {
      clearTimeout(this.rewardsDropdownTimeout)
    }
    if (this.moreDropdownTimeout) {
      clearTimeout(this.moreDropdownTimeout)
    }
    if (this.settingsDropdownTimeout) {
      clearTimeout(this.settingsDropdownTimeout)
    }
    // Восстанавливаем скролл при размонтировании
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
/* Все стили будут добавлены через глобальные CSS файлы */
</style>
